import * as React        from 'react';
import Button            from '@mui/material/Button';
import TextField         from '@mui/material/TextField';
import Dialog            from '@mui/material/Dialog';
import DialogActions     from '@mui/material/DialogActions';
import DialogContent     from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle       from '@mui/material/DialogTitle';
import { Trans }         from 'react-i18next'
import { useApi }        from '../utils/api'
import { useSnackbar }   from 'notistack'
import { useEffect }                                 from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

export default function ServiceOperatorDuplicateDialog({ t, serviceOperator, onServiceOperatorDuplicated }) {

  const api = useApi()
  const [open, setOpen] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar()
  const [operators, setOperators] = React.useState([])

  useEffect(() => {
    api.operator.list().then(response => {
      setOperators(response.data)
    }).catch(() => { /* nothing to do here */ })
  }, [])

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const copy = async (formJson) => {
    try {
      const newItem = await api.serviceOperator.save({ ...serviceOperator, ...formJson, id: undefined })
      enqueueSnackbar(t('Service operator duplicated'), {
        variant: 'success'
      })
      return newItem
    } catch (e) {
      enqueueSnackbar(t('Failed to duplicate service operator'), {
        variant: 'error'
      })
    }
  }

  return (
    <React.Fragment>
      <Button size={'small'} variant={'link'} disableElevation onClick={handleClickOpen}>
        {t('serviceOperator-duplicate')}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault()
            const formData = new FormData(event.currentTarget)
            const formJson = Object.fromEntries(formData.entries())
            copy(formJson).then(newItem => {
              console.log('onServiceOperatorDuplicated', onServiceOperatorDuplicated)
              if (!!onServiceOperatorDuplicated) {
                onServiceOperatorDuplicated(newItem)
              }
            }).catch(() => { /* nothing to do */})
            handleClose();
          },
        }}
      >
        <DialogTitle>{t('serviceOperator-duplicate')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans i18nKey={'serviceOperator-duplicate-desc'} values={{ name: serviceOperator.name }} />
          </DialogContentText>
          <TextField autoFocus required fullWidth
            margin="dense" id="pattern" name="pattern" variant="standard"
            label={t('Pattern')}
            defaultValue={serviceOperator.pattern}
          />
          <TextField autoFocus required fullWidth
                     margin="dense" id="keyword" name="keyword" variant="standard"
                     label={t('Keyword')}
                     defaultValue={serviceOperator.keyword}
          />
          <FormControl variant="standard" fullWidth>
            <InputLabel id="operator">{t('Operator')}</InputLabel>
            <Select
              labelId="operator"
              id="sel-operator"
              name={'operatorId'}
              defaultValue={serviceOperator.operatorId}
              label={t('Operator')}
            >
              {(operators ?? []).map(operator => (<MenuItem key={`operator-${operator.id}`} value={operator.id}>{operator.name}</MenuItem>))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('Cancel')}</Button>
          <Button type="submit">{t('Save')}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}